export default __webpack_public_path__ + "static/media/maple.b9a19bf7.jpg";